import { z } from 'zod/v3';

export const domainPickerValueSchema = z.string();

export const domainPickerUiOptionsSchema = z.object({
  /**
   * Name of the sibling template parameter holding the selected Tenant
   * entity ref. Defaults to "tenant".
   */
  tenantField: z.string().optional(),
});

export type DomainPickerValue = z.infer<typeof domainPickerValueSchema>;
export type DomainPickerUiOptions = z.infer<
  typeof domainPickerUiOptionsSchema
>;
